export const GOAPIPATH = 'https://goapi.dashboard.shortstopburgers.com';
export const PYTHONFLASKPATH = 'https://dashboard.shortstopburgers.com';
export const GOOGLECLIENTID = '1009837764622-u1namikh8apunl8k0lkra2jibiukpi7l.apps.googleusercontent.com';
export const DEV_USER = false; // Set to false in prod.